<div class="empty-list">
    <span>{{ 'DASHBOARD.noAccess' | translate }}</span>
</div>
